import { z } from 'zod';

import { makeEndpoint } from '../common';

export enum StripeAccountStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum StripeAccountServiceAgreement {
  FULL_AGREEMENT = 'full_agreement',
  RECIPIENT = 'recipient',
}

export const CountryCodesThatRequireFullAgreementStripeAccount = [
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'US',
];

export const GetServiceAgreementQuerySchema = z.object({
  brandId: z.string().uuid(),
});

export const GetStripeAccountServiceAgreementTypeResponseSchema = z.object({
  serviceAgreement: z.nativeEnum(StripeAccountServiceAgreement),
});

export const GetStripeAccountServiceAgreementTypeResponseEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId }: { brandId: string }) => `v1/brands/${brandId}/stripe-accounts/service-agreement-type`,
  responseSchema: GetStripeAccountServiceAgreementTypeResponseSchema,
  requestSchema: z.void(),
});
